import React, {Component} from 'react';
import Billboard from "./themoneytizer/Billboard";
import BottomMegabanner from "./themoneytizer/BottomMegabanner";
import BottomRobapaginas from "./themoneytizer/BottomRobapaginas";
import Megabanner from "./themoneytizer/Megabanner";
import MegaSkyscraper from "./themoneytizer/MegaSkyscraper";
import Skyscraper from "./themoneytizer/Skyscraper";
import Splitscreen from "./themoneytizer/Splitscreen";
import {DESKTOP_MODE, MOBILE_MODE} from "../../../config/globalFrontEndConfig";
import Robapaginas from "./themoneytizer/Robapaginas";


export const ADS_TYPES = {
    ROBAPAGINAS: "ROBAPAGINAS",
    SPLITSCREEN: "SPLITSCREEN",
    BOTTOM_ROBAPAGINAS: "BOTTOM_ROBAPAGINAS",
    MEGABANNER: "MEGABANNER",
    BOTTOM_MEGABANNER: "BOTTOM_MEGABANNER",
    SKYSCRAPER: "SKYSCRAPER",
    MEGASKYSCRAPER: "MEGASKYSCRAPER",
    BILLBOARD: "BILLBOARD",
}
const SHORTCODES_THEMONEYTIZER = [
    // {name: "ROBAPÁGINAS (TOP MEDIUM RECTANGLE)", shortcode: '[themoneytizer id="109403-2"]'},
    // {name: "SPLITSCREEN (HALF PAGE)", shortcode: '[themoneytizer id="109403-3"]'},
    // {name: "ROBAPÁGINAS (BOTTOM MEDIUM RECTANGLE)", shortcode: '[themoneytizer id="109403-19"]'},
    // {name: "MEGABANNER", shortcode: '[themoneytizer id="109403-1"]'},
    // {name: "BOTTOM MEGABANNER", shortcode: '[themoneytizer id="109403-28"]'},
    // {name: "SKYSCRAPER", shortcode: '[themoneytizer id="109403-4"]'},
    // {name: "MEGASKYSCRAPER", shortcode: '[themoneytizer id="109403-20"]'},
    // {name: "BILLBOARD", shortcode: '[themoneytizer id="109403-31"]'}
]

export class AdsManagerContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            config: props.config || {},
        }

    }

    render() {
        // console.log("AdsManagerContainer["+this.props.type+"]::render()")
        let show = true
        let style = {}
        const {type, onlyMobile, onlyDesktop} = this.props
        let showDevBanner = false

        if (!(process.env.NODE_ENV === "production" && ["PRO", "PRE"].includes(process.env.DEV_ENV))) {
            showDevBanner = true
        }
        if (onlyMobile && DESKTOP_MODE) show = false
        if (onlyDesktop && MOBILE_MODE) show = false
        if (this.props.sticky) style = {...style, position: "sticky", top: "4rem"}

        if (!show) return (<div className="ads-bloc"/>)
        return (
            <div className="ads-bloc" style={style}>
                {type === ADS_TYPES.ROBAPAGINAS &&
                    <Robapaginas showDevBanner={showDevBanner} onlyDesktop={onlyDesktop} onlyMobile={onlyMobile} sticky={this.props.sticky}/>}

                {type === ADS_TYPES.SPLITSCREEN &&
                    <Splitscreen showDevBanner={showDevBanner} onlyDesktop={onlyDesktop} onlyMobile={onlyMobile} sticky={this.props.sticky}/>}

                {type === ADS_TYPES.BOTTOM_ROBAPAGINAS &&
                    <BottomRobapaginas showDevBanner={showDevBanner} onlyDesktop={onlyDesktop} onlyMobile={onlyMobile}
                                       sticky={this.props.sticky}/>}

                {type === ADS_TYPES.MEGABANNER &&
                    <Megabanner showDevBanner={showDevBanner} onlyDesktop={onlyDesktop} onlyMobile={onlyMobile} sticky={this.props.sticky}/>}

                {type === ADS_TYPES.BOTTOM_MEGABANNER &&
                    <BottomMegabanner showDevBanner={showDevBanner} onlyDesktop={onlyDesktop} onlyMobile={onlyMobile}
                                      sticky={this.props.sticky}/>}

                {type === ADS_TYPES.SKYSCRAPER &&
                    <Skyscraper showDevBanner={showDevBanner} onlyDesktop={onlyDesktop} onlyMobile={onlyMobile} sticky={this.props.sticky}/>}

                {type === ADS_TYPES.MEGASKYSCRAPER &&
                    <MegaSkyscraper showDevBanner={showDevBanner} onlyDesktop={onlyDesktop} onlyMobile={onlyMobile}
                                    sticky={this.props.sticky}/>}

                {type === ADS_TYPES.BILLBOARD &&
                    <Billboard showDevBanner={showDevBanner} onlyDesktop={onlyDesktop} onlyMobile={onlyMobile} sticky={this.props.sticky}/>}

            </div>
        );
    }

    componentWillMount() {

    }

    componentDidMount() {


    }

    componentDidUpdate(prevProps, prevState) {

    }

}
